export default __webpack_public_path__ + "assets/models/00804f7a5692d160c53c396e47ad5dcf.glb";